import React from 'react';

export default function TelegramIcon({ className }) {
	return (
		<svg
			className={className}
			viewBox="0 0 512 512"
			aria-hidden="true"
			focusable="false"
		>
			<path
				fill="currentColor"
				d="M200.895 323.863 192.426 442.988c12.117 0 17.367-5.207 23.66-11.457l56.809-54.25 117.719 86.207c21.59 12.031 36.801 5.695 42.625-19.86l77.269-362.07.02-.023c6.848-31.914-12.539-44.395-33.574-36.563L23.766 218.816c-30.996 12.031-30.527 29.312-5.27 37.141l116.117 36.117 269.719-168.766c12.691-8.406 24.234-3.758 14.738 4.648z"
			/>
		</svg>
	);
}
